"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.objekt_pfeil_nordost = void 0;
const leaflet_1 = __importDefault(require("leaflet"));
exports.objekt_pfeil_nordost = leaflet_1.default.icon({
    iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC6SURBVFhH7ZWxDcIwEEUNLEBJyQiskwrYhE1gE0RHFzEBLR0jwP/4aCKHnMEXS+ie9HWXFHnfkaIEx3FqM5GZwwZZx1XNDWni+js75JGZK5JkKvOvWCF3RPUGSpOSj1agK98jR9nNC6TkZJQCfXJiXuCTnJgWGJITswIaOTEpoJWT4gVy5GSwwEymBsr5wPnrKoQDso1rL/zZXZATcuaNb8k9eVFcXkVOWqSanCwRfj5V5G8WMh3HiBCerAtlhFjJcaEAAAAASUVORK5CYII=",
    iconSize: [32, 32],
});
